import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Linkedin, Facebook, Instagram, Briefcase, User } from "lucide-react";

const XIcon = ({ className }) => (
  <svg viewBox="0 0 24 24" className={className} fill="currentColor"><path d="M18.244 2H21.5l-7.5 8.57L22.75 22h-6.91l-5.41-7.07L4.24 22H1l8.02-9.16L.5 2h7.08l4.89 6.46L18.244 2Zm-1.21 18h1.8L7.05 3.9H5.12L17.03 20Z" /></svg>
);

const SOCIALS = [
  { Icon: Linkedin, href: "https://www.linkedin.com/company/hire-host/" },
  { Icon: Facebook, href: "https://www.facebook.com/Hirehostin" },
  { Icon: Instagram, href: "https://www.instagram.com/hirehostind/" },
  { Icon: XIcon, href: "https://x.com/hirehostind" },
];
import { useLang } from "../context/LanguageContext";

export default function Footer() {
  const { t } = useLang();
  return (
    <footer className="relative bg-[#16233F] pt-16 pb-8 px-6 sm:px-12 text-white" data-testid="footer">
      <div className="max-w-7xl mx-auto grid md:grid-cols-4 gap-12">
        <div className="md:col-span-2">
          <img src="/assets/logo-web.png" alt="Hire Host" className="h-14 w-auto rounded-xl" />
          <p className="mt-5 text-sm text-slate-300 leading-relaxed max-w-sm">{t("footer.about")}</p>
          <p className="mt-4 text-[11px] font-mono text-orange-300/80">{t("footer.license")}</p>
          <div className="flex gap-3 mt-6">
            {SOCIALS.map(({ Icon, href }, i) => (
              <a
                key={i}
                href={href}
                target="_blank"
                rel="noreferrer"
                data-testid={`footer-social-${i}`}
                className="w-10 h-10 rounded-full border border-white/15 flex items-center justify-center text-slate-300 hover:text-white hover:border-[#E8842C] hover:bg-[#E8842C]/20 transition-all"
              >
                <Icon className="w-4 h-4" />
              </a>
            ))}
          </div>
        </div>
        <div>
          <h4 className="font-head font-bold text-white mb-5">{t("footer.contact")}</h4>
          <div className="space-y-4 text-sm text-slate-300">
            <div>
              <p className="text-[10px] uppercase tracking-widest text-orange-300 mb-1 flex items-center gap-1.5"><Briefcase className="w-3 h-3" />{t("footer.for_employers")}</p>
              <a href="tel:+919867288688" data-testid="footer-phone-employers" className="flex items-center gap-2.5 hover:text-[#E8842C] transition-colors">
                <Phone className="w-4 h-4 text-[#E8842C]" /> +91 98672 88688
              </a>
              <a href="mailto:hire@hirehost.in" data-testid="footer-email-employers" className="flex items-center gap-2.5 mt-1 hover:text-[#E8842C] transition-colors">
                <Mail className="w-4 h-4 text-[#E8842C]" /> hire@hirehost.in
              </a>
            </div>
            <div>
              <p className="text-[10px] uppercase tracking-widest text-orange-300 mb-1 flex items-center gap-1.5"><User className="w-3 h-3" />{t("footer.for_employees")}</p>
              <a href="tel:+919136635698" data-testid="footer-phone-employees" className="flex items-center gap-2.5 hover:text-[#E8842C] transition-colors">
                <Phone className="w-4 h-4 text-[#E8842C]" /> +91 91366 35698
              </a>
              <a href="mailto:resume@hirehost.in" data-testid="footer-email-employees" className="flex items-center gap-2.5 mt-1 hover:text-[#E8842C] transition-colors">
                <Mail className="w-4 h-4 text-[#E8842C]" /> resume@hirehost.in
              </a>
            </div>
          </div>
        </div>
        <div>
          <h4 className="font-head font-bold text-white mb-5">{t("footer.links")}</h4>
          <div className="space-y-2.5 text-sm text-slate-300">
            <Link to="/about" data-testid="footer-link-about" className="block hover:text-[#E8842C] transition-colors">{t("nav.about_company")}</Link>
            <Link to="/team" data-testid="footer-link-team" className="block hover:text-[#E8842C] transition-colors">{t("nav.meet_team")}</Link>
            <Link to="/solutions" data-testid="footer-link-solutions" className="block hover:text-[#E8842C] transition-colors">{t("nav.our_solutions")}</Link>
            <Link to="/employer#inquiry" data-testid="footer-link-inquiry" className="block hover:text-[#E8842C] transition-colors">{t("nav.inquire")}</Link>
            <Link to="/faq" data-testid="footer-link-faq" className="block hover:text-[#E8842C] transition-colors">{t("nav.faq")}</Link>
            <Link to="/contact" data-testid="footer-link-contact" className="block hover:text-[#E8842C] transition-colors">{t("nav.contact")}</Link>
          </div>
          <p className="flex items-start gap-2.5 text-xs text-slate-400 leading-relaxed mt-6">
            <MapPin className="w-4 h-4 text-[#E8842C] mt-0.5 shrink-0" /> {t("footer.office")}
          </p>
        </div>
      </div>
      <div className="max-w-7xl mx-auto mt-12 pt-6 border-t border-white/10">
        <p className="text-xs text-slate-400 text-center">© {new Date().getFullYear()} Hire Host — {t("footer.rights")}</p>
      </div>
    </footer>
  );
}
